export default `
  subscription OnUpdateCards($workflowId: String!)  {
    onUpdateCards (workflowId: $workflowId) {
      workflowId
      version
      updatedAt
      updateNote {
        userRealName
        action
        target
      }
      cards {
        cardId
        cardIndex
        description
        sortkey
        cardTypeId
        releaseNo
        done
        version
        eventId
        eventIndex
        boundedContext
        schemaId
        tags
      }
    }
  }
`
